import useWishlistBase from 'commerceAPI/hooks/useWishlist';

const DEFAULT_WISHLIST_NAME = '';

export const useWishlist = (opts = {}) => {
	const useBaseWishlist = useWishlistBase({
		wishlistName: DEFAULT_WISHLIST_NAME,
		...opts
	});

	return {
		...useBaseWishlist
	};
};
